




















































































import Vue from 'vue';
import { ObjectType, ReferenceData, DefinitionsDataReference } from 'expangine-runtime';
import { TypeUpdateEvent, TypeSettings } from '../runtime/types/TypeVisuals';
import { Preferences, PreferenceCategory } from './Preference';
import { LiveRuntime } from 'expangine-runtime-live';
import { getConfirmation } from './Confirm';
import { Registry } from '../runtime/Registry';
import { sendNotification } from './Notify';


const PREF_REMOVE_DATA = Preferences.define({
  key: 'data_remove',
  label: 'Remove data without confirmation',
  category: [PreferenceCategory.CONFIRM],
  defaultValue: false,
});

export default Vue.extend({
  props: {
    data: {
      type: Object as () => ReferenceData,
      required: true,
    },
    registry: {
      type: Object as () => Registry,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    hideName: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tab: 0,
  }),
  computed: {
    settings(): TypeSettings {
      if (this.registry.getTypeSettingsValidFor(this.data.dataType, this.data.meta)) {
        return this.data.meta;
      }
      
      return this.data.meta = this.registry.getTypeSettings(this.data.dataType);
    },
    references(): DefinitionsDataReference[] {
      return this.registry.defs.getDataReferences(this.data);
    },
  },
  methods: {
    renamed(newName: string) {
      const { registry, data } = this;
      const { defs } = registry;

      if (data.name) {
        const updates = defs.renameData(data.name, newName);
        
        if (updates && updates.length) {
          sendNotification({ message: `${updates.length} Data reference(s) updated` });
        }
        
        this.$emit('renamed', this.data);
      } else {
        data.name = newName;

        defs.addData(data);
      }
    },
    validateName(name: string) {
      if (!name) {
        return 'A name is required.';
      }

      const existing = this.registry.defs.getData(name);
      if (existing && existing !== this.data) {
        return 'Data already exists with that name.';
      }

      return '';
    },
    async remove() {
      if (!await getConfirmation({ message: `Are you sure you want to remove this data?`, pref: PREF_REMOVE_DATA })) {
        return;
      }

      const removed = this.registry.defs.removeData(this.data);

      if (!removed) {
        sendNotification({ message: 'You cannot remove referenced data.' });
      } else {
        this.$emit('removed', this.data);
      }
    },
    onChange(event: TypeUpdateEvent) {
      this.data.dataType = event.type as ObjectType;
      this.data.meta = event.settings;

      if (event.transform) {
        this.data.refactor(event.transform, LiveRuntime);
      }
    },
    onDataChange(data: any) {
      this.data.data = data;
    },
  },
});
